<template>
    <div id="main">
        <div class="page">
            <div class="meu-promotor">
                <!-- BREADCRUMB -->
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ colaborador }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a>{{ $t('promotor') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'meuspromotores-list' })">{{
                                        $t('mypromoters')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ colaborador }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <!-- BOTÕES -->
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            @click="$router.push({ name: 'meuspromotores-list' })"
                        >
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>

                <div class="mapa-meu-promotor mapa-wrapper">
                    <gmap-map
                        ref="mapRef"
                        class="gmaps"
                        :center="center"
                        :zoom="zoomLevel"
                        :options="mapOptions"
                    >
                        <!-- Marcador e polyline da rota definida -->
                        <gmap-marker
                            v-for="(m, index) in lps"
                            :position="m.position"
                            :icon="m.icon"
                            :key="index"
                            @click="openInfo(m)"
                        />

                        <gmap-polyline :path="path" :options="pathConfig" :editable="false" />

                        <!-- Marcador e polyline da posição capturada no checkin do atendimento ao clicar em um pin -->
                        <gmap-marker
                            v-if="
                                infoWindow.item.lps &&
                                infoWindow.item.lps.estado != 'nao-atendido' &&
                                infoWindow.open
                            "
                            :position="infoWindow.item.atendimentoPos"
                            :icon="atendimentoIcon"
                            :clickable="false"
                        />

                        <gmap-polyline
                            v-if="
                                infoWindow.item.lps &&
                                infoWindow.item.lps.estado != 'nao-atendido' &&
                                infoWindow.open
                            "
                            :path="pathAtendimento"
                            :options="pathConfigAtendimento"
                            :editable="false"
                        />

                        <gmap-info-window
                            ref="infoWindow"
                            :position="infoWindow.position"
                            :opened="infoWindow.open"
                            :options="infoWindow.options"
                            @closeclick="infoWindow.open = false"
                        >
                            <div class="info-window" v-if="infoWindow.item.lps">
                                <p class="info-window-nome">
                                    {{ infoWindow.item.lps.rsocial.toLocaleUpperCase() }}
                                </p>
                                <div class="info-details">
                                    <div class="info-detail">
                                        <span>{{ $t('horario-previsto') }}:</span>
                                        <span v-if="infoWindow.item.horarios.sugerido">{{
                                            [infoWindow.item.horarios.sugerido, 'HH:mm:ss']
                                                | moment('LT')
                                        }}</span>
                                        <span v-else>{{ $t('nao-informado') }}</span>
                                    </div>

                                    <div
                                        class="info-detail"
                                        v-if="infoWindow.item.horarios.entrada"
                                    >
                                        <span>{{ $t('horario-entrada') }}:</span>
                                        <span>{{
                                            infoWindow.item.horarios.entrada | moment('LT')
                                        }}</span>
                                    </div>

                                    <div
                                        class="info-detail"
                                        v-if="
                                            infoWindow.item.horarios.saida &&
                                            infoWindow.item.lps.estado == 'atendido'
                                        "
                                    >
                                        <span>{{ $t('horario-saida') }}:</span>
                                        <span>{{
                                            infoWindow.item.horarios.saida | moment('LT')
                                        }}</span>
                                    </div>

                                    <div
                                        class="info-detail"
                                        v-if="
                                            infoWindow.item.horarios.entrada &&
                                            infoWindow.item.horarios.saida &&
                                            infoWindow.item.lps.estado == 'atendido'
                                        "
                                    >
                                        <span>{{ $t('duracao') }}:</span>
                                        <span>{{
                                            $moment(infoWindow.item.horarios.saida).diff(
                                                $moment(infoWindow.item.horarios.entrada)
                                            ) | duration('humanize')
                                        }}</span>
                                    </div>

                                    <div
                                        class="info-detail"
                                        v-if="infoWindow.item.horarios.justificativa"
                                    >
                                        <span>{{ $t('justificativa') }}:</span>
                                        <span>{{
                                            infoWindow.item.horarios.justificativa.toLocaleUpperCase()
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </gmap-info-window>
                    </gmap-map>

                    <div class="legenda">
                        <div class="legenda-item">
                            <svg class="svg-icons nao-atendido">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/map-marker.svg') + '#layer'
                                    "
                                ></use>
                            </svg>
                            <span> {{ $t('nao-atendido') }} </span>
                        </div>
                        <div class="legenda-item">
                            <svg class="svg-icons em-atendimento">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/map-marker.svg') + '#layer'
                                    "
                                ></use>
                            </svg>
                            <span> {{ $t('em-atendimento') }} </span>
                        </div>
                        <div class="legenda-item">
                            <svg class="svg-icons atendido">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/map-marker.svg') + '#layer'
                                    "
                                ></use>
                            </svg>
                            <span> {{ $t('atendido') }} </span>
                        </div>
                        <div class="legenda-item">
                            <svg class="svg-icons captura">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/map-marker.svg') + '#layer'
                                    "
                                ></use>
                            </svg>
                            <span> {{ $t('local-checkin') }} </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Botão de retrair -->
        <div
            ref="retractBtn"
            class="retract-button"
            :class="{ 'hide-control-right-btn': !showPanel }"
            @click="showPanel = !showPanel"
            v-show="!loadingMap && !$root.gmapsFailure"
        >
            <div class="btn-wrapper">
                <b-icon :icon="showPanel ? 'chevron-right' : 'chevron-left'" />
            </div>
        </div>

        <!-- Lista de Status - Dentro do Mapa -->
        <div
            ref="listaStatus"
            class="control-right"
            :class="{ 'hide-control-right': !showPanel }"
            v-show="!loadingMap && !$root.gmapsFailure"
        >
            <!-- Alert container movido pra dentro da lista que fica dentro do maps; Permite que os avisos apareçam em full screen -->
            <alert-container :messages="msgs" />
            <div class="control-container padded">
                <div class="vertical-flow">
                    <div class="form-columns-fit">
                        <div class="columns is-flex-wrap">
                            <div class="column is-12">
                                <verified-date-picker
                                    ref="dataInput"
                                    id="saida"
                                    v-model="dataAtendimento"
                                    title="data"
                                    @input="changeDate"
                                    :disabled="loadingData"
                                    :inForm="true"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-columns-fit">
                        <div class="columns is-flex-wrap">
                            <div class="column is-12">
                                <button class="button btn-search" @click="loadAtendimentos">
                                    {{ $t('pesquisar') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Message from '@/models/Message';
import MeusPromotoresService from '@/services/MeusPromotoresService';
import ColaboradorService from '@/services/ColaboradorService';

export default {
    data() {
        return {
            id: this.$route.params.id,
            colaborador: '',
            msgs: [],
            service: new MeusPromotoresService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            center: { lat: -12.867, lng: -55.625 },
            zoomLevel: 4,
            loadingMap: true,
            loadingData: false,
            showPanel: false,
            mapOptions: {
                mapTypeControl: false,
                streetViewControl: false,
                scaleControl: false,
                zoomControl: false,
                fullscreenControl: true,
                clickableIcons: false,
                fullscreenControlOptions: {
                    position: 7, //google.maps.ControlPosition.RIGHT_TOP
                },
            },
            pathConfig: {
                strokeColor: `#000`,
                strokeOpacity: 1,
                icons: [
                    {
                        // icon: { path: 1 /*google.maps.SymbolPath.FORWARD_OPEN_ARROW*/ },
                        icon: { path: 'M 2,3 0,0 -2,3', strokeOpacity: 1, scale: 3 },
                        offset: '40%',
                        repeat: '50px',
                    },
                ],
                zIndex: 10,
            },
            pathConfigAtendimento: {
                strokecolor: '#000',
                strokeOpacity: 0,
                icons: [
                    {
                        icon: {
                            path: 'M 0,-1 0,1',
                            scale: 4,
                            strokeColor: '#818181',
                            strokeOpacity: 0.8,
                        },
                        offset: '0',
                        repeat: '25px',
                    },
                ],
                zIndex: 10,
            },
            path: [],
            pathAtendimento: [],
            rota: {},
            lps: [],
            dataAtendimento: null,
            svgpath:
                'M10.0812 0.00417221V0C10.0537 0 10.0269 0.00166887 10 0.00166887C9.97313 0.00166887 9.94626 0 9.91877 0V0.00417221C4.42628 0.0930404 0 4.64555 0 10.2528C0 17.8089 8.72292 24.9809 10 26C11.2773 24.9811 20 17.8087 20 10.2528C20 4.64555 15.5739 0.0930404 10.0812 0.00417221ZM10.0812 14.663C7.20729 14.663 4.87795 12.2945 4.87795 9.37205C4.87795 6.44879 7.20729 4.0798 10.0812 4.0798C12.9552 4.0798 15.2847 6.44879 15.2847 9.37205C15.2847 12.2945 12.9552 14.663 10.0812 14.663Z',
            colors: {
                naoAtendido: '#F44336',
                emAtendimento: '#FFC107',
                atendido: '#4CAF50',
            },
            infoWindow: {
                position: { lat: 0, lng: 0 },
                open: false,
                item: {},
                options: {
                    pixelOffset: { width: 0, height: -30 },
                },
            },
            atendimentoIcon: {
                path:
                    'M10.0812 0.00417221V0C10.0537 0 10.0269 0.00166887 10 0.00166887C9.97313 0.00166887 9.94626 0 9.91877 0V0.00417221C4.42628 0.0930404 0 4.64555 0 10.2528C0 17.8089 8.72292 24.9809 10 26C11.2773 24.9811 20 17.8087 20 10.2528C20 4.64555 15.5739 0.0930404 10.0812 0.00417221ZM10.0812 14.663C7.20729 14.663 4.87795 12.2945 4.87795 9.37205C4.87795 6.44879 7.20729 4.0798 10.0812 4.0798C12.9552 4.0798 15.2847 6.44879 15.2847 9.37205C15.2847 12.2945 12.9552 14.663 10.0812 14.663Z',
                fillColor: '#3F3F3F',
                scale: 1,
                fillOpacity: 1,
                strokeWeight: 0,
                anchor: { x: 10, y: 25 },
            },
        };
    },

    created() {
        this.permissao = this.hasPermissionAccess('promotor', 'mypromoters', 'meuspromotores');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'mypromoter' },
            });
        } else {
            this.dataAtendimento = new Date();

            this.$store.commit('addLoader');

            this.colaboradorService
                .find(this.$route.params.id)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro status ${r.status} ao carregar informações do colaborador ID ${this.$route.params.id}`
                        );
                        console.error(r.message);
                    } else {
                        let status = this.$route.params.status;
                        this.colaborador = r.content.nome;

                        if (status && status != 'ocioso') {
                            this.loadAtendimentos();
                        } else {
                            this.showPanel = true;
                        }
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao carregar informações do colaborador ID ${this.$route.params.id}`,
                        e
                    );
                })
                .finally((_) => {
                    if (!status || status == 'ocioso') {
                        this.$store.commit('removeLoader');
                    }
                });
        }
    },
    mounted() {
        this.$refs.mapRef.$mapPromise.then((map) => {
            this.loadingMap = false;
            map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$refs.retractBtn);
            map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$refs.listaStatus);

            setTimeout(() => {
                this.gmnoprintZindex();
            }, 1000);
        });
    },
    methods: {
        showMessage(msg) {
            this.gmnoprintZindex();
            const { type, message } = msg;
            this.msgs.push(new Message(type, message, true));
        },
        loadAtendimentos() {
            this.path = [];
            this.pathAtendimento = [];
            this.lps = [];
            this.infoWindow.open = false;
            this.loadingData = true;

            let data = this.$moment(this.dataAtendimento).format('YYYY-MM-DD');

            this.$store.commit('addLoader');

            this.service
                .getRoutes(this.id, data)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro status ${r.status} ao carregar dados de rota do promotor.`
                        );
                        console.error(`Mensagem: [${r.message}]`);
                        this.showMessage({ type: 'error', message: 'msg-erro-load-rota' });
                    } else {
                        this.rota = r.content;

                        if (this.rota.definida && this.rota.definida.length > 0) {
                            this.getPins();
                        } else {
                            console.log(
                                `Não há LPS em rota definida para o dia ${this.dataAtendimento}.`
                            );
                            this.showMessage({ type: 'alert', message: 'msg-no-lps-in-route' });
                        }
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar dados de rota do promotor.', e);
                    this.showMessage({ type: 'error', message: 'msg-erro-load-rota' });
                })
                .finally((_) => {
                    this.loadingData = false;
                    this.$store.commit('removeLoader');
                });
        },
        getPins() {
            this.pathConfig.strokeColor = document.documentElement.style.getPropertyValue(
                '--primary-color-click'
            );

            this.$refs.mapRef.$mapPromise.then((map) => {
                this.lps = [];

                this.rota.definida.forEach((r) => {
                    let executado = this.rota.percorrida.find((e) => e.lps.id == r.lps.id);
                    let color = this.colors.naoAtendido;
                    let estado = 'nao-atendido';

                    if (
                        executado &&
                        executado.qtdecontratos >= r.qtdecontratos &&
                        executado.horaentrada &&
                        executado.horasaida
                    ) {
                        color = this.colors.atendido;
                        estado = 'atendido';
                    } else if (executado && executado.qtdecontratos > 0) {
                        color = this.colors.emAtendimento;
                        estado = 'em-atendimento';
                    }

                    let marker = {
                        lps: { ...r.lps, estado },
                        horarios: {
                            sugerido: r.horaentrada,
                            entrada: executado ? executado.horaentrada : null,
                            saida: executado ? executado.horasaida : null,
                            justificativa: executado ? executado.justificativa : null,
                        },
                        position: {
                            lat: parseFloat(r.lps.latitude),
                            lng: parseFloat(r.lps.longitude),
                        },
                        atendimentoPos: {
                            lat: executado ? parseFloat(executado.lps.latitude) : null,
                            lng: executado ? parseFloat(executado.lps.longitude) : null,
                        },
                        icon: {
                            path: this.svgpath,
                            fillColor: color,
                            scale: 1,
                            fillOpacity: 1,
                            strokeWeight: 0,
                            anchor: { x: 10, y: 25 },
                        },
                    };

                    this.lps.push(marker);
                });

                let bounds = new google.maps.LatLngBounds();
                this.path = [];

                this.lps.forEach((m) => {
                    this.path.push(m.position);
                    bounds.extend(m.position);
                });

                map.fitBounds(bounds);
            });
        },
        openInfo(m) {
            if (this.infoWindow.item.lps && m.lps.id == this.infoWindow.item.lps.id) {
                this.infoWindow.open = !this.infoWindow.open;
            } else {
                this.infoWindow.open = true;
            }

            this.infoWindow.position = m.position;
            this.infoWindow.item = m;
            this.pathAtendimento = [m.position, m.atendimentoPos];
        },
        gmnoprintZindex() {
            // Removendo o z-index dos avisos de copyright do mapa para o aviso poder aparecer normal e em full screen
            document.querySelectorAll('.gmnoprint').forEach((e) => {
                if (e.style.zIndex) {
                    e.style.zIndex = 0;
                }
            });
        },
        changeDate(date) {
            this.dataAtendimento = date;
        },
    },
};
</script>

<style lang="scss" scoped>
.control-right {
    min-height: 400px;
}

@mixin smallbtn() {
    height: 28px;
    font-size: 12px;
    color: $sovis-white;
    @include gradient-button();
}

#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        margin-bottom: 15px;

        .meu-promotor {
            height: 100%;

            .mapa-meu-promotor {
                height: calc(100% - 90px);
                padding-top: 10px;

                .gmaps {
                    height: 100%;
                }
            }

            .legenda {
                display: flex;
                justify-content: space-around;
                height: 30px;
                border-left: 1px solid $table-border;
                border-right: 1px solid $table-border;
                border-bottom: 1px solid $table-border;
                border-bottom-right-radius: 3px;
                border-bottom-left-radius: 3px;

                .legenda-item {
                    display: flex;
                    align-items: center;
                    font-size: 14px;

                    span {
                        color: $darker-gray-color;
                        font-weight: 600;
                        padding-left: 5px;
                    }
                }

                .nao-atendido {
                    fill: #f44336;
                }
                .em-atendimento {
                    fill: #ffc107;
                }
                .atendido {
                    fill: #4caf50;
                }
                .captura {
                    fill: #3f3f3f;
                }
            }
        }

        .control-container {
            .data-atendimento {
                .data-input {
                    flex-grow: 1;
                }

                button {
                    margin-top: 14px;
                    margin-left: 5px;
                    height: 26px;

                    &:hover {
                        color: $sovis-white;
                    }
                }
            }
        }
    }
}

button {
    &.btn-add-small {
        @include smallbtn();
    }

    &.btn-del-small {
        @include smallbtn();
        @include exclude-button();
        color: $darker-gray-color;
    }
}

@media only screen and (max-width: 760px) {
    #main {
        padding: 0 20px !important;

        .page .meu-promotor {
            .mapa-meu-promotor .gmaps {
                height: calc(100vh - 270px);
            }

            .legenda {
                flex-wrap: wrap;
                min-height: 30px;
                height: auto;
                padding: 5px 0;
            }
        }
    }
}
</style>
